module.exports = __webpack_public_path__ + "static/media/logo.cdb611dd.gif";